var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { TextInput } from "../atoms";
/**
 * SearchInput - A reusable search input component with integrated search icon
 *
 * Provides a clean search input with the search icon positioned inside the input field.
 * Focused on search functionality without additional UI elements.
 */
var SearchInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.placeholder, placeholder = _b === void 0 ? "Search..." : _b, _c = _a.width, width = _c === void 0 ? "300px" : _c, _d = _a.className, className = _d === void 0 ? "" : _d, _e = _a.style, style = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? "medium" : _f, _g = _a.fullWidth, fullWidth = _g === void 0 ? false : _g;
    return (React.createElement("div", { className: "search-input-container ".concat(className), style: __assign({ width: fullWidth ? "100%" : width }, style) },
        React.createElement(TextInput, { type: "search", placeholder: placeholder, value: value, onChange: onChange, icon: faSearch, iconPosition: "left", size: size, fullWidth: true })));
};
export default SearchInput;
